module.exports = __webpack_public_path__ + "img/popup_2026_28_05.2d8c8c84.png";